import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { AuthLayout, GoogleButton } from "@/pages/Login";

const FIELDS = [
  { k: "name", label: "Nome e cognome", type: "text" },
  { k: "company", label: "Officina / Azienda (opzionale)", type: "text", optional: true },
  { k: "phone", label: "Cellulare WhatsApp", type: "tel", placeholder: "Es. 333 1234567" },
  { k: "email", label: "Email", type: "email" },
  { k: "password", label: "Password (min. 6 caratteri)", type: "password" },
];

export default function Register() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", company: "", phone: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/register", form);
      login(data);
      navigate("/dashboard");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title="Crea account" subtitle="Per autoriparatori e committenti che richiedono supporto tecnico.">
      <form onSubmit={submit} className="space-y-4">
        {FIELDS.map((f) => (
          <div key={f.k}>
            <label className="label">{f.label}</label>
            <input className="field" type={f.type} required={!f.optional} minLength={f.k === "password" ? 6 : undefined}
              placeholder={f.placeholder} value={form[f.k]} data-testid={`register-${f.k}-input`}
              onChange={(e) => setForm({ ...form, [f.k]: e.target.value })} />
          </div>
        ))}
        {error && <div className="text-sm text-red-400" data-testid="register-error">{error}</div>}
        <button className="btn-red w-full py-3 flex items-center justify-center gap-2" disabled={busy} data-testid="register-submit-button">
          {busy && <Loader2 size={16} className="animate-spin" />} Registrati
        </button>
      </form>
      <div className="my-6"><GoogleButton /></div>
      <p className="text-sm text-slate-400">
        Hai già un account? <Link to="/login" className="text-[#E50914] font-semibold hover:underline" data-testid="go-login-link">Accedi</Link>
      </p>
    </AuthLayout>
  );
}
